// This lists all the farms providing this order and allows the user
// to select which farms they want to download invoices for.  Then they
// will download an invoice for each selected farm.
import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Box from "@material-ui/core/Box";
import CreateFarmInvoice from "./functions/CreateFarmInvoice.js";

// This will cycle through and generate an invoice for each farm.
function DownloadFarmerInvoices(
  selectedFarms,
  foodList,
  farmList,
  selectedDate,
  etransferEmail,
) {
  selectedFarms.forEach((farm) => {
    const farmFoodList = foodList.filter((item) => item.farmName === farm);

    CreateFarmInvoice(
      farm,
      farmFoodList,
      farmList,
      selectedDate,
      etransferEmail,
    );
  });
}

// This is the dialog box that opens when a user clicks on DOWNLOAD FARM INVOICES
function FarmerInvoicesBox({
  onClose,
  open,
  farmTotals,
  foodList,
  farmList,
  selectedDate,
  etransferEmail,
}) {
  const handleClose = () => {
    onClose(false);
  };
  const [selectedFarms, setSelectedFarms] = useState([]);

  const handleToggle = (location) => {
    setSelectedFarms((prevSelected) =>
      prevSelected.includes(location)
        ? prevSelected.filter((loc) => loc !== location)
        : [...prevSelected, location],
    );
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        Please Select the Locations to Download
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column">
          {Object.keys(farmTotals).map((farm) => (
            <FormControlLabel
              key={farm}
              control={
                <Checkbox
                  checked={selectedFarms.includes(farm)}
                  onChange={() => handleToggle(farm)}
                  name={farm}
                />
              }
              label={farm}
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleClose}>
          CLOSE
        </Button>
        {selectedFarms.length > 0 && (
          <Button
            color="primary"
            onClick={() =>
              DownloadFarmerInvoices(
                selectedFarms,
                foodList,
                farmList,
                selectedDate,
                etransferEmail,
              )
            }
          >
            DOWNLOAD
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

FarmerInvoicesBox.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedDate: PropTypes.string.isRequired,
  distributionLocation: PropTypes.string.isRequired,
  downloadGridString: PropTypes.string.isRequired,
  // farmTotals: PropTypes.object.isRequired,
};

export default function FarmerInvoicesDialog({
  farmTotals,
  foodList,
  farmList,
  selectedDate,
  etransferEmail,
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        onClick={handleClickOpen}
        style={{
          marginBottom: "10px",
          border: "1px solid #2196f3",
          borderRadius: "5px",
          color: "#2196f3",
          padding: "10px 20px",
          width: "100%",
        }}
      >
        DOWNLOAD FARM INVOICES
      </Button>

      <FarmerInvoicesBox
        open={open}
        onClose={handleClose}
        farmTotals={farmTotals}
        foodList={foodList}
        farmList={farmList}
        selectedDate={selectedDate}
        etransferEmail={etransferEmail}
      />
    </div>
  );
}
